import { makeStyles } from '@material-ui/styles';
import { React, useState } from 'react';

const RatingFB = (props) => {

    const classes = useStyles();
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    return (
        <div style={{width: "100%", textAlign: "center"}}>
            {[...Array(5)].map((star, index) => {
                index += 1;
                return (
                    <button
                        type="button"
                        key={index}
                        className={index <= (hover || rating) ? classes.on : classes.off}
                        onClick={() => {setRating(index); props.setRating(index)}}
                        onMouseEnter={() => setHover(index)}
                        onMouseLeave={() => setHover(rating)}
                    >
                        <span className="star">&#9733;</span>
                    </button>
                );
            })}
        </div>
    );
}

const useStyles = makeStyles(() => ({
    button: {
        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    on: {
        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        color: "#53252f",
        fontSize: "200%"
    },
    off: {
        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        color: "#ccc",
        fontSize: "200%"
    }

}));

export default RatingFB;
